<br />
<div *ngFor="let entry of entries; let i = index">
  <app-timeline-item [entry]="entry" [showYear]="showYearForEntry[i]"></app-timeline-item>
</div>
<br />
